export const Others = {
    'Digital Strategy': 5.56,
    'Business Model': 5.10,
    'Enablers': 5.18,
    'Orchestration': 4.98
};

export const BarColors = {
    'Digital Strategy': '#c6aa3c',
    'Business Model': '#c00',
    'Enablers': '#517967',
    'Orchestration': '#4d6f8a'
};

export const Leaders = {
    'Digital Strategy': 6.34,
    'Business Model': 6.14,
    'Enablers': 6.18,
    'Orchestration': 6.13
};

export const Buckets = {
    Scaling: 'scaling',
    Strategy: 'strategy',
    Business: 'business',
    Enablers: 'enablers',
    Orchestration: 'orchestration'
};

export const RatingCategory = [
    Buckets.Strategy,
    Buckets.Business,
    Buckets.Enablers,
    Buckets.Orchestration,
];

export const COMPREHENSIVE_INSIGHTS = {
    Scaling: "DRS-Comprehensive-Insights-Scaling",
    Strategy: "DRS-Comprehensive-Insights-Strategy",
    Business: "DRS-Comprehensive-Insights-Business-Model",
    Enablers: "DRS-Comprehensive-Insights-Enablers",
    Orchestration: "DRS-Comprehensive-Insights-Orchestration",
};

export const INDUSTRYTYPES = {
    'Consumer Products': {
        value: 0, name: "Consumer Products", articleFeed: "DRS-Consumer-Products", overall: {
            'Digital Strategy': 5.49,
            'Business Model': 5.03,
            'Enablers': 5.19,
            'Orchestration': 4.92
        }
    },
    'Financial Services': {
        value: 1, name: "Financial Services", articleFeed: "DRS-Financial-Services", overall: {
            'Digital Strategy': 5.49,
            'Business Model': 5.16,
            'Enablers': 5.25,
            'Orchestration': 5.12
        }
    },
    'Advanced Manufacturing & Services': {
        value: 1, name: "Advance Manufacturing & Services", articleFeed: "DRS-Advanced-Manufacturing", overall: {
            'Digital Strategy': 5.52,
            'Business Model': 5.11,
            'Enablers': 5.26,
            'Orchestration': 5.09
        }
    },
    'Energy & Natural Resources': {
        value: 1, name: "Energy & Natural Resources", articleFeed: "DRS-Energy-Natural-Resources", overall: {
            'Digital Strategy': 5.46,
            'Business Model': 4.88,
            'Enablers': 5.07,
            'Orchestration': 4.94
        }
    },
    'Healthcare': {
        value: 2, name: "Healthcare", articleFeed: "DRS-Healthcare", overall: {
            'Digital Strategy': 5.56,
            'Business Model': 5.10,
            'Enablers': 5.32,
            'Orchestration': 4.99
        }
    },
    'Industrial': { value: 3, name: "Industrial", articleFeed: "DRS-Industrials" },
    'Media': {
        value: 4, name: "Media", articleFeed: "DRS-Media", overall: {
            'Digital Strategy': 5.32,
            'Business Model': 5.56,
            'Enablers': 5.11,
            'Orchestration': 5.22
        }
    },
    'Oil & Gas/Energy': { value: 5, name: "Oil & Gas/Energy", articleFeed: "DRS-oil-and-gas-energy" },
    'Private Equity': { value: 6, name: "Private Equity", articleFeed: "DRS-Private-Equity" },
    'Retail': {
        value: 7, name: "Retail", articleFeed: "DRS-Retail", overall: {
            'Digital Strategy': 5.42,
            'Business Model': 5.14,
            'Enablers': 5.19,
            'Orchestration': 4.92
        }
    },
    'Technology': {
        value: 8, name: "Technology", articleFeed: "DRS-Technology", overall: {
            'Digital Strategy': 5.83,
            'Business Model': 5.55,
            'Enablers': 5.58,
            'Orchestration': 5.45
        }
    },
    'Telecom': {
        value: 9, name: "Telecom", articleFeed: "DRS-Telecom", overall: {
            'Digital Strategy': 5.59,
            'Business Model': 5.26,
            'Enablers': 5.22,
            'Orchestration': 5.19
        }
    },
    'Other': { value: 9, name: "Other", articleFeed: "DRS-Other" },
};



// WEBPACK FOOTER //
// ./src/constants.js